/* eslint-disable import/prefer-default-export */
const edgesMatrix = [[1421, 1578, 1811, 5480, 1151, 2997],
  [1368, 6401, 2331, 8477, 1722, 4573],
  [1543, 2294, 3785, 10126, 1451, 4514],
  [2907, 5200, 6818, 42385, 2864, 10018],
  [1111, 1774, 1576, 5335, 1866, 3128],
  [2147, 3811, 3971, 13663, 2463, 11485]];

export { edgesMatrix };
